import React from 'react';
import styled from 'styled-components';
import IconLocalShipping from '@tvg/fuse-icons/lib/LocalShipping';
import { SkeletonText, Icon } from '@tvg/fuse-design';

const SkeletonContainer = styled.div`
  display: flex;
  margin-bottom: var(--spacing-space16);
`;

const IconContainer = styled.div`
  flex: 0 0 32px;
  position: relative;
`;

const SkeletonLinesContainer = styled.div`
  display: flex;
  flex: 1 1 0%;
  align-items: center;
  margin-left: var(--spacing-space12);
`;

export default function Skeleton() {
  return (
    <SkeletonContainer>
      <IconContainer>
        <Icon icon={<IconLocalShipping />} width="32px" height="32px" dataTestId="delivery-card-icon" />
      </IconContainer>
      <SkeletonLinesContainer>
        <SkeletonText
          lineHeight="m2"
          width={{
            s: '90%',
            l: '85%',
          }}
        />
      </SkeletonLinesContainer>
    </SkeletonContainer>
  );
}
